import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { Component, ElementRef, computed, input, viewChild } from '@angular/core';

import { Order } from '../../common/Order';
import {
  DEFAULT_RECEIPT_WIDTH_CM,
  ReceiptWatermark,
  buyerName,
  receiptPositions,
  receiptTotals,
  sellerName,
} from './order-receipt';

/**
 * One order as a receipt-printer slip (#205): the seller, the order, the customer, a line per
 * position and the totals — laid out at the paper's width, so the preview is the print.
 *
 * Presentational only. The order page and the settings page's test print both render it, and
 * hand {@link sheet} to `ReceiptPrinter`.
 */
@Component({
  selector: 'app-order-receipt',
  imports: [CurrencyPipe, DatePipe, DecimalPipe],
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.css'],
})
export class OrderReceiptComponent {
  readonly order = input.required<Order>();
  readonly widthCm = input<number>(DEFAULT_RECEIPT_WIDTH_CM);
  readonly watermark = input<ReceiptWatermark | null>(null);

  /** The slip itself — what gets printed, and nothing around it. */
  readonly sheet = viewChild.required<ElementRef<HTMLElement>>('sheet');

  protected readonly positions = computed(() => receiptPositions(this.order()));
  protected readonly totals = computed(() => receiptTotals(this.positions()));
  protected readonly sellerName = computed(() => sellerName(this.order()));
  protected readonly buyerName = computed(() => buyerName(this.order()));
}
